<template>
    <ExtendedLayout
        :project="project"
        currentTab="feeds"
    >

        <Panel>

            <Heading type="h2" class="flex items-center gap-2">
                <InertiaLink :href="$route('admin::projects.feeds.index', { project: project.id })">
                    {{ __('admin::feeds.feeds') }}
                </InertiaLink>
                <ChevronRightIcon class="h-4 w-4 text-gray-600" />
                <span>{{ feed.name }}</span>
            </Heading>

            <form @submit.prevent="submit">

                <FormGroup :label="__('admin::labels.name')" :error="errors.name">
                    <Input name="name" type="text" :has-error="exists(errors.name)" v-model="form.name" :required="true" />
                </FormGroup>

                <FormGroup :label="__('admin::labels.type')" :error="errors.type">
                    <Select name="type" :options="typeOptions" :has-error="exists(errors.type)" v-model="form.type" :required="true" :allow-empty="false" />
                </FormGroup>

                <FormGroup :label="__('admin::labels.url')" :error="errors.url" v-if="form.type !== 'manual'">
                    <Input name="url" type="text" :has-error="exists(errors.url)" v-model="form.url" :required="true" />
                </FormGroup>

                <FormGroup :label="__('admin::labels.status')" :error="errors.status" v-if="project.type === 'multi_feed'">
                    <Select name="status" :options="statusOptions" :has-error="exists(errors.status)" v-model="form.status" :required="false" :allow-empty="true" />
                </FormGroup>

                <FormGroup :label="__('admin::labels.department')" :error="errors.department_id" v-if="project.type === 'multi_feed'">
                    <Select name="department_id" :options="departmentOptions" :has-error="exists(errors.department_id)" v-model="form.department_id" :required="false" :allow-empty="true" />
                </FormGroup>

                <div class="grid grid-cols-2 gap-4">
                    <FormGroup :label="__('admin::labels.latitude')" :error="errors.latitude">
                        <Input name="latitude" type="number" step="any" :has-error="exists(errors.latitude)" v-model="form.latitude" :required="false" />
                    </FormGroup>

                    <FormGroup :label="__('admin::labels.longitude')" :error="errors.longitude">
                        <Input name="longitude" type="number" step="any" :has-error="exists(errors.longitude)" v-model="form.longitude" :required="false" />
                    </FormGroup>
                </div>

                <div v-if="feed.type !== 'manual'">
                    <div v-if="! feedColumns" class="text-red-600 font-bold mb-6">
                        {{ __('admins::feeds.no_columns_found_in_url') }}
                    </div>

                    <div class="bg-gray-50 rounded-md shadow-md divide-y divide-gray-200 mb-6 overflow-hidden" v-else>

                        <div
                            v-for="(optionName, optionKey) in columnOptions"
                            :key="optionKey"
                            class="grid grid-cols-3 gap-4 items-center p-4"
                            :class="{
                                'bg-sky-100': form.mapping[optionKey].value
                            }"
                        >

                            <div class="">
                                <strong>{{ optionName }}</strong>
                            </div>

                            <div class="">
                                <Select :options="{ column: __('admin::feeds.mapping_type_column'), static: __('admin::feeds.mapping_type_static') }" v-model="form.mapping[optionKey].type" :allow-empty="false" />
                            </div>

                            <div class="">
                                <Input type="text" v-model="form.mapping[optionKey].value" :required="false" v-if="form.mapping[optionKey].type === 'static'" />
                                <Select :options="feedColumns" v-model="form.mapping[optionKey].value" :allow-empty="true" v-else />
                            </div>

                        </div>

                    </div>
                </div>

                <Button :loading="form.processing">
                    {{ __('admin::general.update_model', {'model': __('admin::feeds.feed').toLowerCase() }) }}
                </Button>

            </form>

        </Panel>

    </ExtendedLayout>
</template>

<script>
import ExtendedLayout from '@/Pages/Projects/Edit';
import Panel from "@/Components/Panel";
import Button from "@/Components/Button";
import FormGroup from "@/Components/FormGroup";
import Input from "@/Components/Input";
import Heading from "@/Components/Heading";
import {ChevronRightIcon} from "@heroicons/vue/outline";
import Select from "@/Components/Select";

export default {
    components: {
        Select,
        ChevronRightIcon,
        Heading,
        Input,
        FormGroup,
        Button,
        Panel,
        ExtendedLayout,
    },
    props: {
        errors: Object,
        project: Object,
        feed: Object,
        typeOptions: Object,
        statusOptions: Object,
        departmentOptions: Object,
        columnOptions: Object,
        feedColumns: Object,
    },
    data() {
        return {
            form: this.$inertia.form({
                name: this.feed.name,
                type: this.feed.type,
                url: this.feed.url,
                status: this.feed.status || '',
                department_id: this.feed.department_id || '',
                latitude: this.feed.latitude,
                longitude: this.feed.longitude,
                mapping: {},
            })
        }
    },
    created() {
        const mapping = {};

        for (let property in this.columnOptions) {

            let existingMapping = this.feed.mapping && property in this.feed.mapping
                ? this.feed.mapping[property]
                : null;

            mapping[property] = {
                type: existingMapping ? existingMapping.type : 'column',
                value: existingMapping && existingMapping.value ? existingMapping.value : '',
            };
        }

        this.form.mapping = mapping;
    },
    methods: {
        submit() {
            this.form
                .transform((data) => ({
                    ...data,
                    _method: 'patch',
                }))
                .post(this.$route('admin::projects.feeds.update', { project: this.project.id, feed: this.feed.id }));
        }
    },
}
</script>
